import React, { useEffect, useMemo } from 'react';
import { useCategories, useCategoriesFetch } from 'src/features/common/category/hooks/category.hooks';
import { StyledItem } from './styles';

interface IProps {
    subcategoryIds: string[];
}

const componentTestId = 'category-list';

const CategoryList = ({ subcategoryIds }: IProps) => {
    const categories = useCategories();
    const categoriesFetch = useCategoriesFetch();
    const filteredCategories = useMemo(() => (
        categories.filter(category => subcategoryIds.includes(category.id))
    ), [categories, subcategoryIds]);

    useEffect(() => {
        if (!categories.length) {
            categoriesFetch();
        }
    }, [categories.length, categoriesFetch]);

    const categoryList = useMemo(() => (
        filteredCategories.map((category) => (
            <StyledItem
                key={`category-${category.id}`}
                data-test-id={`${componentTestId}-name`}
            >
                {category.name}
            </StyledItem>
        ))
    ), [filteredCategories]);

    return <div>{categoryList}</div>;
};

export default CategoryList;
